import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { QuickNavWrapper, QuickNavItem, NavLabel } from "./styles";
import { Tooltip, Zoom } from "@material-ui/core";

export const PatientQuickNav = () => {
    const location = useLocation();

    const menuItems = [
        {
            nombre: "Atención",
            url: "/paciente/atencion",
            icon: "fas fa-user-md",
        },
        {
            nombre: "Odontograma",
            url: "/paciente/odontograma",
            icon: "fas fa-tooth",
        },
        {
            nombre: "Historia",
            url: "/paciente/historia",
            icon: "fas fa-file-medical",
        },
        {
            nombre: "Recetas",
            url: "/paciente/recetas",
            icon: "fas fa-prescription-bottle-alt",
        },
    ];

    return (
        <QuickNavWrapper>
            {menuItems.map((item) => (
                <Tooltip
                    key={item.url}
                    title={item.nombre}
                    TransitionComponent={Zoom}
                    placement="top"
                    disableFocusListener
                    disableTouchListener
                >
                    <QuickNavItem
                        as={NavLink}
                        to={item.url}
                        activeClassName="active"
                    >
                        <i className={item.icon}></i>
                        <NavLabel>{item.nombre}</NavLabel>
                    </QuickNavItem>
                </Tooltip>
            ))}
        </QuickNavWrapper>
    );
};
